import React, { useEffect, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton from '@divvy-web/skylab.basicbutton'
import Modal from '@divvy-web/skylab.modal'

import { useAuth } from '@sputnik/auth'
import { LogoutButton } from '@sputnik/components'
import useBdcOrgID from '@sputnik/hooks/useBdcOrgID'

const timeToShowWarning = 2 * 60
const timeToAutoSave = timeToShowWarning - 10

export interface TimeoutPromptModalProps {
  formSubmit: (() => void) | null
}

const TimeoutPromptModal = ({ formSubmit }: TimeoutPromptModalProps) => {
  const { appId } = useParams()
  const location = useLocation()
  const { logout, refreshAuthToken, authenticatedSecondsRemaining, isUserIdle } = useAuth()
  const hasFormBeenAutoSubmitted = useRef(false)
  const [bdcOrgId] = useBdcOrgID(appId)

  useEffect(() => {
    if (authenticatedSecondsRemaining <= timeToAutoSave && isUserIdle && !hasFormBeenAutoSubmitted.current) {
      formSubmit?.()
      hasFormBeenAutoSubmitted.current = true
      return
    }
    if (authenticatedSecondsRemaining < 1) {
      logout({
        location,
        reason: 'CountdownEnded',
        source: 'TimeoutPrompt',
      })
    }
  }, [formSubmit, logout, authenticatedSecondsRemaining, isUserIdle, location])

  const handleResumeClick = async () => {
    await refreshAuthToken()
    hasFormBeenAutoSubmitted.current = false
  }

  return (
    <Modal
      actions={[
        <LogoutButton
          key='logout'
          bdcOrgId={bdcOrgId}
        />,
        <BasicButton
          key='resume'
          onClick={handleResumeClick}
        >
          <FormattedMessage
            defaultMessage='Resume'
            id='sputnik.TimeoutPrompt__3y9DGg'
          />
        </BasicButton>,
      ]}
      isShowing={authenticatedSecondsRemaining <= timeToShowWarning}
    >
      <FormattedMessage
        defaultMessage='Your session is about to expire. Would you like to continue editing? If you take no action, you will be logged out automatically.'
        id='sputnik.TimeoutPromptModal__JQ+wxd'
      />
    </Modal>
  )
}

export default TimeoutPromptModal
